import React from "react";
import { useNavigate } from "react-router-dom";

// Imports
import TitleText from "./TitleText";
import SubTitleText from "./SubTitleText";

const testData = [
  { title: "Blood", img: "/assets/blood-icon.svg" },
  { title: "Liver", img: "/assets/liver-icon.svg" },
  { title: "Heart", img: "/assets/heart-icon.svg" },
  { title: "Kidney", img: "/assets/kidney-icon.svg" },
  { title: "Bones", img: "/assets/bones-icon.svg" },
];

const PersonalisedTests = () => {
  const navigate = useNavigate();

  const fetchFilterUrl = (filter = "Blood") => {
    navigate(`/risk-based-testing/${filter}`);
  };

  return (
    <div className="w-full h-fit bg-white flex flex-col justify-start items-center p-[3%] lg:p-[2%]">
      {/* <TitleText text="Personalized Risk-Based Testing" /> */}
        <h1 className="font-semibold w-3/4 text-lg text-center sm:text-[22px] lg:text-[24px] text-textPrimaryColor">
        Personalized Risk-Based Testing for Better Health
        </h1>
      <div className="w-full lg:w-[50%] h-fit mt-[3%] lg:mt-[1%]">
        <SubTitleText text="Discover specialized diagnostic tests focused on assessing vital organ health. Our diagnosis centres in India provide accurate insights, helping you take proactive steps toward better well-being." />
      </div>
      <div className="w-full h-fit flex flex-wrap justify-center items-center lg:space-x-10 mt-[5%] lg:mt-[2%]">
        {testData?.map((item, index) => (
          <div
            className="flex flex-col justify-center items-center space-y-3 cursor-pointer p-[3%] lg:p-0"
            key={index}
          >
            <img
              src={item.img}
              alt="test-icon"
              onClick={() => fetchFilterUrl(item.title)}
            />
            <span className="font-semibold text-[4vw] lg:text-[0.9vw] text-textPrimaryColor">
              {item.title}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PersonalisedTests;
